module.exports = __webpack_public_path__ + "img/03.c2cc8d84.png";